import {getNewWatchlistId, Watchlist} from './watchlist';
import {WatchlistDefinition} from './watchlist-definitnion';

export class WatchlistFactory {

    public static createWatchlistByDefinition(watchlistDef: WatchlistDefinition): Watchlist {
        return {
            id:      watchlistDef.id || getNewWatchlistId(),
            name:    watchlistDef.name,
            symbols: watchlistDef.symbols ? watchlistDef.symbols.slice() : []
        };
    }

    public static getWatchlistDefinition(watchlist: Watchlist): WatchlistDefinition {
        return {
            id:      watchlist.id,
            name:    watchlist.name,
            symbols: watchlist.symbols ? watchlist.symbols.slice() : []
        };
    }

    public static createWatchlistsByDefinition(watchlistDefs: WatchlistDefinition[]): Watchlist[] {
        let watchlists: Watchlist[];

        try {
            watchlists = (watchlistDefs || []).map(WatchlistFactory.createWatchlistByDefinition);
        } catch (error) {
            console.warn('[WatchlistFactory] Invalid watchlist definition.', error);
        }

        return watchlists;
    }

    public static makeWatchlistReadonly(watchlist: Watchlist): Watchlist {
        return {
            ...watchlist,
            isReadonly: true
        };
    }

    public static getDefaultEmptyWatchlist(): WatchlistDefinition {
        return WatchlistFactory.createWatchlistByDefinition({
            id:      undefined,
            name:    'Default',
            symbols: []
        });
    }

}
